import Parse from "parse";

//play background video
let video = document.querySelector(".main-video-background");
const form = document.querySelector(".main-form");
const nameField = document.querySelector("#field-1");
const emailField = document.querySelector("#field-2");
const organisationField = document.querySelector("#field-3");
const marketingCheckbox = document.querySelector("#marketing-checkbox");
const marketingWrapper = document.querySelector(".marketing-wrapper");
const submitButton = document.querySelector(".form-submit");
marketingWrapper.addEventListener("click", () => {
	marketingCheckbox.checked = !marketingCheckbox.checked;
});
export function initialiseApp() {
	//initialise connection to the backend
	Parse.initialize(
		"9cdVVpXAfExtZoArYYJ3LEdpwLkRUgHhdD19Bmgm",
		"q85a2g7dOZ5pWHrzH97I7HqcwaThrBPKedz1bCDy"
	);
	Parse.serverURL = "https://parseapi.back4app.com/";
	//add the onsubmit functionality
	form?.addEventListener("submit", (e) => {
		e.preventDefault();
		if (validate() == true) {
			token();
		}
	});
}
function validate() {
	//check validity of fields
	let nameValid = nameField.checkValidity();
	let emailValid = emailField.checkValidity();
	let organisationValid = organisationField.checkValidity();
	//return false if any fields are not valid and report it - show error on form
	if (nameValid == false) {
		nameField.reportValidity();
		return false;
	}
	if (emailValid == false) {
		emailField.reportValidity();
		return false;
	}
	if (organisationValid == false) {
		organisationField.reportValidity();
		return false;
	}
	//return collective validiity
	return nameValid && emailValid && organisationValid;
}
async function token() {
	try {
		submitButton.classList.add("form-submit-progress");
		submitButton.textContent = "Submitting...";
		await Parse.Cloud.run("token").then((response) => {
			if (response) {
				post(response);
			}
		});
	} catch (error) {
		submitButton.classList.remove("form-submit-progress");
		submitButton.textContent = "Submit and enter experience";
		console.log(error);
	}
}
async function post(token) {
	try {
		await Parse.Cloud.run("login", {
			fullName: nameField.value,
			email: emailField.value,
			organisation: organisationField.value,
			marketingComms: marketingCheckbox.checked,
			dateTime: new Date(Date.now()).toUTCString(),
			token: token,
		}).then(() => {
			// redirect to destination url
			window.location.href =
				"https://virtualshowroom.sharp.co.uk/home/?token=a7bGf9pR3t2qL6sP1wXo5";
		});
	} catch (error) {
		submitButton.classList.remove("form-submit-progress");
		submitButton.textContent = "Submit and enter experience";
		switch (error.code) {
			case 101:
				alert("An error has occured, please try again.");
				break;
		}
	}
}
